export default "__VITE_ASSET__Dj5JxaNb__"